import { Switch } from './ui/switch';
import './small-atoms.css';
import { useTranslation } from '../i18n/I18nContext';

/**
 * AvailableOnlyFilter - toggle для показа только доступных машин
 *
 * Скрывает машины со статусом "Reserved" (statusSold === 'yes')
 */
const AvailableOnlyFilter = ({ checked, onChange, className = '' }) => {
  const { t } = useTranslation();
  return (
    <div className={`filter-inline ${className}`.trim()}>
      <Switch
        id="available-only-switch"
        checked={checked}
        onChange={onChange}
        label={t('showcase.catalog.availableOnly', 'Available only')}
      />
    </div>
  );
};

export default AvailableOnlyFilter;
